import { Link } from "react-router-dom";
import { Calendar, CheckCircle2, CreditCard, PhoneIncoming, Send } from "lucide-react";
import { BrowserFrame, FloatBadge } from "../Frames";
import { AppStoreBadge, GooglePlayBadge } from "../MkBadges";

const TRUST_ITEMS = ["No credit card required", "7-day free trial", "Cancel anytime"];

const HomeHero = ({ onBookDemo }) => (
  <section className="relative pt-28 md:pt-40 pb-16 md:pb-24 bg-gradient-to-b from-blue-50/70 via-white to-slate-50/40 overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      aria-hidden="true"
      style={{ background: "radial-gradient(ellipse 900px 420px at 50% -10%, rgba(0,70,190,0.08) 0%, transparent 70%)" }}
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="max-w-3xl mx-auto text-center mb-14 md:mb-20">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[var(--mk-blue)] mb-5" data-testid="hero-eyebrow">
          Field Service Management Software
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.08] mb-6" data-testid="hero-heading">
          Run Your Entire Field Service Business From One Platform
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto mb-9">
          Stop juggling separate apps for dispatch, CRM, phone calls, estimates, and invoicing. Fieldz AI connects your
          office, field technicians, and finances into one powerful system.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5 mb-6">
          <Link to="/register" className="mk-btn mk-btn-primary mk-btn-lg w-full sm:w-auto" data-testid="hero-start-free-trial-button">
            Start Free for 7 Days
          </Link>
          <button onClick={onBookDemo} className="mk-btn mk-btn-outline mk-btn-lg w-full sm:w-auto" data-testid="hero-book-demo-button">
            <Calendar className="w-4 h-4" /> Book a Demo
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8">
          {TRUST_ITEMS.map((t) => (
            <span key={t} className="flex items-center gap-1.5 text-sm text-slate-500 font-medium">
              <CheckCircle2 className="w-4 h-4 text-emerald-600" /> {t}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-center gap-3">
          <AppStoreBadge />
          <GooglePlayBadge />
        </div>
      </div>

      <div className="relative max-w-5xl mx-auto" data-testid="hero-screenshot-wrap">
        <div className="rounded-3xl bg-gradient-to-tr from-blue-50/60 via-white to-indigo-50/40 p-3 sm:p-6 border border-slate-200/60">
          <BrowserFrame
            src="/marketing/fieldz-ai-field-service-dashboard.webp"
            alt="Fieldz AI field service management dashboard showing jobs, revenue, and dispatch overview"
            url="fieldzai.com/dashboard"
            eager
          />
        </div>
        <FloatBadge
          icon={CreditCard}
          text="Payment collected — $725.00"
          className="mk-float -top-4 right-2 sm:top-10 sm:-right-5"
          iconClassName="text-emerald-600"
        />
        <FloatBadge
          icon={Send}
          text="Job dispatched to Chris R."
          className="mk-float mk-float-delay -bottom-4 left-2 sm:bottom-16 sm:-left-6"
        />
        <FloatBadge
          icon={PhoneIncoming}
          text="Incoming call — matched to customer"
          className="hidden md:flex mk-float top-1/2 -left-8"
          iconClassName="text-sky-600"
        />
      </div>
    </div>
  </section>
);

export default HomeHero;
